import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import loadVimeo from "../apiLoaders/loadVimeo";
import BasePlayerEmbed from "./BasePlayerEmbed";
import { canPublish } from "../utilities";
import { fireEnd, firePause, firePlay } from "../analytics";

var VimeoPlayerEmbed = /*#__PURE__*/function (_Component) {
  _inherits(VimeoPlayerEmbed, _Component);

  var _super = _createSuper(VimeoPlayerEmbed);

  function VimeoPlayerEmbed() {
    var _this;

    _classCallCheck(this, VimeoPlayerEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleFrameReady", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iframe) {
        var Vimeo, player, videoMetadata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.props.analytics || canPublish())) {
                  _context.next = 27;
                  break;
                }

                _context.next = 3;
                return loadVimeo();

              case 3:
                Vimeo = _context.sent;
                player = new Vimeo.Player(iframe);
                videoMetadata = {
                  id: _this.props.videoId,
                  type: "Vimeo"
                }; // We should try to find the title before we fire any analytics events

                _context.prev = 6;
                _context.next = 9;
                return player.getVideoTitle();

              case 9:
                videoMetadata.title = _context.sent;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                // eslint-disable-next-line no-console
                console.warn("Could not get a video title from Vimeo for video ID ".concat(_this.props.videoId));

              case 15:
                VimeoPlayerEmbed.addAnalyticsToPlayer(player, videoMetadata, _this.props.analytics); // Manually fire the initial play event - Vimeo won't do this for us.

                _context.t1 = firePlay;
                _context.t2 = _objectSpread;
                _context.t3 = _objectSpread({}, videoMetadata);
                _context.t4 = {};
                _context.next = 22;
                return player.getDuration();

              case 22:
                _context.t5 = _context.sent;
                _context.t6 = {
                  currentTime: 0,
                  duration: _context.t5
                };
                _context.t7 = (0, _context.t2)(_context.t3, _context.t4, _context.t6);
                _context.t8 = _this.props.analytics;
                (0, _context.t1)(_context.t7, _context.t8);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 12]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(VimeoPlayerEmbed, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          videoId = _this$props.videoId,
          extra = _objectWithoutProperties(_this$props, ["videoId"]);

      var frameUrl = "https://player.vimeo.com/video/".concat(videoId, "?api=1&autoplay=1&html5=1");
      return /*#__PURE__*/React.createElement(BasePlayerEmbed, _extends({
        src: frameUrl,
        onFrameReady: this.handleFrameReady
      }, extra));
    }
  }], [{
    key: "eventToMetadata",
    value: function eventToMetadata(e) {
      return {
        currentTime: e.seconds || 0,
        duration: e.duration || 0
      };
    }
  }, {
    key: "addAnalyticsToPlayer",
    value: function addAnalyticsToPlayer(player, videoMetadata, analytics) {
      player.on("play", function (e) {
        return firePlay(_objectSpread(_objectSpread({}, videoMetadata), VimeoPlayerEmbed.eventToMetadata(e)), analytics);
      });
      player.on("pause", function (e) {
        return firePause(_objectSpread(_objectSpread({}, videoMetadata), VimeoPlayerEmbed.eventToMetadata(e)), analytics);
      });
      player.on("finish", function (e) {
        return fireEnd(_objectSpread(_objectSpread({}, videoMetadata), VimeoPlayerEmbed.eventToMetadata(e)), analytics);
      });
    }
  }]);

  return VimeoPlayerEmbed;
}(Component);

export default VimeoPlayerEmbed;